<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning">
            <span class="text" v-html="message" style="line-height: 2rem;"></span>
          </div>
          <div class="action text-right">
            <a @click="$emit('close')" class="btn btn-primary">{{confirmText}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'NoticeModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '確定'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapGetters(['BaseUrl'])
  },
}
</script>
